module.exports = __webpack_public_path__ + "img-dashboard/register/unggah-foto.48540615.png";